import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import styles from "./skeleton.module.less"
import {SkeletonType} from "@src/CommonComponents/SkeletonPlaceHolder/SkeletonType.ts";
import {SkeletonPlaceHolder} from "@src/CommonComponents/SkeletonPlaceHolder/SkeletonPlaceHolder.tsx";
import {Colors} from "@UI/theme/generated/Colors.ts";
import cn from "classnames";


const Header = () => {
    return (
        <Stack justifyContent={"space-between"} className={styles.header} alignItems={"center"}>
            <Stack gap={16} className={styles.infoBlock} alignItems={"center"}>
                <SkeletonPlaceHolder type={SkeletonType.text} height={10} width={120}/>
                <SkeletonPlaceHolder type={SkeletonType.rectangle} height={20} width={20}/>
                <SkeletonPlaceHolder type={SkeletonType.text} height={10} width={60}/>
            </Stack>
            <Stack className={styles.button}>
                <SkeletonPlaceHolder type={SkeletonType.rectangle} height={30} width={30}/>
            </Stack>
        </Stack>
    )
}

export const CheckInOutSkeleton = () => {
    return (
        <Stack direction={"column"} justifyContent={"flex-start"}>
            <Header/>
            <Stack direction={"column"} gap={8} className={styles.body} justifyContent={"center"}>
                <Stack direction={"column"} className={styles.clouds} gap={8} justifyContent={"center"}
                       alignItems={"center"}>
                    <Stack gap={4} style={{flexWrap: "wrap"}} justifyContent={"center"}>
                        <Stack className={cn(styles.cloud, styles.smallCloud)} direction={"column"} alignItems={"center"}
                               justifyContent={"center"}>
                            <SkeletonPlaceHolder type={SkeletonType.rectangle} height={10} width={24}
                                                 color={Colors.Obsidian_Light_200}/>
                            <SkeletonPlaceHolder type={SkeletonType.rectangle} height={10} width={66}
                                                 color={Colors.Obsidian_Light_200}/>
                        </Stack>
                        <Stack className={cn(styles.cloud, styles.smallCloud)} direction={"column"} alignItems={"center"}
                               justifyContent={"center"}>
                            <SkeletonPlaceHolder type={SkeletonType.rectangle} height={10} width={24}
                                                 color={Colors.Obsidian_Light_200}/>
                            <SkeletonPlaceHolder type={SkeletonType.rectangle} height={10} width={66}
                                                 color={Colors.Obsidian_Light_200}/>
                        </Stack>
                        <Stack className={cn(styles.cloud, styles.smallCloud)} direction={"column"} alignItems={"center"}
                               justifyContent={"center"}>
                            <SkeletonPlaceHolder type={SkeletonType.rectangle} height={10} width={24}
                                                 color={Colors.Obsidian_Light_200}/>
                            <SkeletonPlaceHolder type={SkeletonType.rectangle} height={10} width={66}
                                                 color={Colors.Obsidian_Light_200}/>
                        </Stack>
                    </Stack>
                    <Stack alignItems={"center"} justifyContent={"center"} className={styles.clouds}>
                        <Stack className={cn(styles.cloud, styles.smallCloud)} direction={"column"} alignItems={"center"}
                               justifyContent={"center"} />
                    </Stack>
                </Stack>
                <Stack className={styles.wideButton}>
                    <SkeletonPlaceHolder type={SkeletonType.rectangle} height={48} width={"100%"}
                                         borderRadius={14}
                                         color={Colors.Obsidian_Light_100}/>
                </Stack>
                <Stack className={styles.detailClouds} direction={"column"} gap={16}>
                    <Stack className={styles.cloud} direction={"column"}
                           gap={24}>
                        <Stack className={styles.cloudContent} justifyContent={"space-between"}>
                            <Stack direction={"column"} gap={17} justifyContent={"center"}>
                                <SkeletonPlaceHolder type={SkeletonType.rectangle} height={10} width={110}
                                                     color={Colors.Obsidian_Light_200}/>
                                <SkeletonPlaceHolder type={SkeletonType.rectangle} height={10} width={176}
                                                     color={Colors.Obsidian_Light_200}/>
                            </Stack>

                            <SkeletonPlaceHolder type={SkeletonType.rectangle} height={28} width={80}
                                                 borderRadius={14}
                                                 color={Colors.Obsidian_Light_200}/>
                        </Stack>
                        <Stack className={styles.wideButton}>
                            <SkeletonPlaceHolder type={SkeletonType.rectangle} height={48} width={"100%"}
                                                 borderRadius={14}
                                                 color={Colors.Obsidian_Light_200}/>
                        </Stack>
                    </Stack>
                    <Stack className={styles.cloud} direction={"column"}
                           gap={24}>
                        <Stack className={styles.cloudContent} justifyContent={"space-between"}>
                            <Stack direction={"column"} gap={17} justifyContent={"center"}>
                                <SkeletonPlaceHolder type={SkeletonType.rectangle} height={10} width={110}
                                                     color={Colors.Obsidian_Light_200}/>
                                <SkeletonPlaceHolder type={SkeletonType.rectangle} height={10} width={176}
                                                     color={Colors.Obsidian_Light_200}/>
                            </Stack>

                            <SkeletonPlaceHolder type={SkeletonType.rectangle} height={28} width={80}
                                                 borderRadius={14}
                                                 color={Colors.Obsidian_Light_200}/>
                        </Stack>
                        <Stack className={styles.wideButton}>
                            <SkeletonPlaceHolder type={SkeletonType.rectangle} height={48} width={"100%"}
                                                 borderRadius={14}
                                                 color={Colors.Obsidian_Light_200}/>
                        </Stack>
                    </Stack>
                    <Stack className={styles.cloud} direction={"column"}
                           gap={24}>
                        <Stack className={styles.cloudContent} justifyContent={"space-between"}>
                            <Stack direction={"column"} gap={17} justifyContent={"center"}>
                                <SkeletonPlaceHolder type={SkeletonType.rectangle} height={10} width={110}
                                                     color={Colors.Obsidian_Light_200}/>
                                <SkeletonPlaceHolder type={SkeletonType.rectangle} height={10} width={176}
                                                     color={Colors.Obsidian_Light_200}/>
                            </Stack>

                            <SkeletonPlaceHolder type={SkeletonType.rectangle} height={28} width={80}
                                                 borderRadius={14}
                                                 color={Colors.Obsidian_Light_200}/>
                        </Stack>
                        <Stack className={styles.wideButton}>
                            <SkeletonPlaceHolder type={SkeletonType.rectangle} height={48} width={"100%"}
                                                 borderRadius={14}
                                                 color={Colors.Obsidian_Light_200}/>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack>

    )
}